//#region src/lib/admin-rbac/admin-role.ts
let AdminRole = /* @__PURE__ */ function(AdminRole) {
	AdminRole["Superadmin"] = "superadmin";
	AdminRole["MarketplaceRead"] = "marketplace:read";
	AdminRole["MarketplaceOrderSupport"] = "marketplace:order-support";
	AdminRole["MarketplaceUserManagement"] = "marketplace:user-management";
	AdminRole["MarketplaceCoupons"] = "marketplace:coupons";
	AdminRole["MarketplaceFinance"] = "marketplace:finance";
	AdminRole["IntegrationsAdmin"] = "integrations:admin";
	AdminRole["CatalogueRead"] = "catalogue:read";
	AdminRole["CatalogueWrite"] = "catalogue:write";
	AdminRole["CatalogueDeploy"] = "catalogue:deploy";
	AdminRole["DiscordRead"] = "discord:read";
	AdminRole["DiscordAdmin"] = "discord:admin";
	AdminRole["ScannerAdmin"] = "scanner:admin";
	AdminRole["EventsManage"] = "events:manage";
	return AdminRole;
}({});
const ALL_MARKETPLACE_ROLES = [
	AdminRole.MarketplaceRead,
	AdminRole.MarketplaceOrderSupport,
	AdminRole.MarketplaceUserManagement,
	AdminRole.MarketplaceCoupons,
	AdminRole.MarketplaceFinance
];
const ALL_CATALOGUE_ROLES = [
	AdminRole.CatalogueRead,
	AdminRole.CatalogueWrite,
	AdminRole.CatalogueDeploy
];
const ALL_DISCORD_ROLES = [AdminRole.DiscordRead, AdminRole.DiscordAdmin];

//#endregion
export { ALL_CATALOGUE_ROLES, ALL_DISCORD_ROLES, ALL_MARKETPLACE_ROLES, AdminRole };
//# sourceMappingURL=admin-role.js.map